var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex"}},[_c('div',[_c('span',[_vm._v("Категорії товарів")]),_c('MenuNode',{attrs:{"nodes":_vm.menuNodes}})],1),_c('div',[_c('span',[_vm._v("Інформаційні сторінки")]),_c('MenuNode2',{attrs:{"nodes":_vm.menuNodes}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }